export enum ResourceStatusEnum {
  'created' = 'created',
  'converted' = 'converted',
}
